import ButtonLoader from './ButtonLoader.js'
export { ButtonLoader }



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Loader/index.js